// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"6d25de7d","647":"6fdf4217","668":"fe1bc6b6","787":"08848d99","974":"9f55ae5f"}[chunkId] + ".chunk.js";
};